import React, { useEffect } from 'react'
import { CCol, CWidgetDropdown, CSpinner } from '@coreui/react'
import { getStyle } from '@coreui/utils'
import { CChartLine } from '@coreui/react-chartjs'
import CIcon from '@coreui/icons-react'
import { cilArrowBottom, cilArrowTop } from '@coreui/icons'
import useAxios from 'axios-hooks'
import { RAVEN_ANALYTICS_API } from 'src/views/utils/urls'

const UserCard = ({ getDateLabels }) => {
  const [{ data: userData }, userDataCall] = useAxios(
    {
      url: `${RAVEN_ANALYTICS_API}/user-card`,
      method: 'get',
    },
    { manual: true },
  )

  useEffect(() => {
    userDataCall({
      params: {
        delta_window: 90,
        unit_window: 15,
        num_data_points: 12,
      },
    })
  }, [])
  return (
    <CCol sm={6} lg={3}>
      <CWidgetDropdown
        className="mb-4"
        color="primary"
        value={userData?.data ? userData?.data?.num_current_users : <CSpinner color="light" />}
        change={
          userData?.data && (
            <>
              ({Number(userData?.data?.percentage_delta).toFixed(1)}%
              {userData?.data?.percentage_delta > 0 ? (
                <CIcon icon={cilArrowTop} />
              ) : (
                <CIcon icon={cilArrowBottom} />
              )}
              )
            </>
          )
        }
        title="Users"
        chart={
          <CChartLine
            className="mt-3 mx-3 pb-1"
            style={{ height: '70px' }}
            data={{
              labels: getDateLabels(2, 12),
              datasets: [
                {
                  label: 'No. of Users',
                  backgroundColor: 'rgba(255,255,255,.2)',
                  borderColor: 'rgba(255,255,255,.55)',
                  pointBackgroundColor: getStyle('--cui-primary'),
                  data: userData?.data?.data_points,
                  fill: true,
                },
              ],
            }}
            options={{
              plugins: {
                legend: {
                  display: false,
                },
              },
              maintainAspectRatio: false,
              scales: {
                x: {
                  display: false,
                },
                y: {
                  display: false,
                },
              },
              elements: {
                line: {
                  borderWidth: 1,
                  tension: 0.4,
                },
                point: {
                  radius: 4,
                  hitRadius: 10,
                  hoverRadius: 4,
                },
              },
            }}

            // options={{
            //   plugins: {
            //     legend: {
            //       display: false,
            //     },
            //   },
            //   maintainAspectRatio: false,
            //   scales: {
            //     x: {
            //       grid: {
            //         display: false,
            //         drawBorder: false,
            //       },
            //       ticks: {
            //         display: false,
            //       },
            //     },
            //     y: {
            //       min: userData ? Math.min(...userData?.data_points) - 3.5 : 0,
            //       max: userData ? Math.max(...userData?.data_points) + 3.5 : 100,
            //       display: false,
            //       grid: {
            //         display: false,
            //       },
            //       ticks: {
            //         display: false,
            //       },
            //     },
            //   },
            //   elements: {
            //     line: {
            //       borderWidth: 1,
            //       tension: 0.4,
            //     },
            //     point: {
            //       radius: 4,
            //       hitRadius: 10,
            //       hoverRadius: 4,
            //     },
            //   },
            // }}
          />
        }
      />
    </CCol>
  )
}

export default UserCard
